import { createAsyncThunk } from '@reduxjs/toolkit'
import { getSingleStats } from './api'

export const getStats = createAsyncThunk('Stats/getStats', async () => {
  const res = await getSingleStats()
  return res.data
})
